// PocketBase client singleton.
//
// The base URL comes from the Vite env var VITE_PB_URL (see .env.example).
// In local dev with no backend running, calls will reject — every consumer
// in this app is written to fall back to a read-only / guest experience,
// so a missing or unreachable server degrades gracefully instead of crashing.
import PocketBase from "pocketbase";

const PB_URL = import.meta.env.VITE_PB_URL || "http://127.0.0.1:8090";

export const pb = new PocketBase(PB_URL);

// Keep auth state across reloads (PocketBase persists to localStorage by
// default via its LocalAuthStore — this is just an explicit hook point).
pb.autoCancellation(false);

export { PB_URL };
